"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HomeHeroCarousel() {
  const slides = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/professional_studio_photography.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/professional_studio_photography.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/professional_studio_photography.webp-wvc-sizes",
    alt: "Professional studio photography session",
    caption: "Expert Portraits — Riyadh Studio",
    location: "Al Wadi, Riyadh"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/canon_pro_6600_printing.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/canon_pro_6600_printing.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/canon_pro_6600_printing.png-wvc-sizes",
    alt: "Canon Pro 6600 large scale printing",
    caption: "Precision Printing — Canon Pro 6600",
    location: "Industrial Press"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/custom_scenery_decor.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/custom_scenery_decor.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/custom_scenery_decor.png-wvc-sizes",
    alt: "Custom scenery and home decor",
    caption: "Custom Decor — Digital to Physical",
    location: "Art & Decor"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/cinematic_videography_event.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/cinematic_videography_event.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/cinematic_videography_event.png-wvc-sizes",
    alt: "Cinematic event videography",
    caption: "Cinematic Videography — Events",
    location: "Professional Coverage"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/passport_photo_service.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/passport_photo_service.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1555315/img/passport_photo_service.png-wvc-sizes",
    alt: "Passport photo service",
    caption: "Passport Photos — All Countries",
    location: "Studio Services"
  }];
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length]);
  const currentSlide = slides[current];
  const slideNumber = String(current + 1).padStart(2, "0");
  const totalSlides = String(slides.length).padStart(2, "0");
  return <section data-section-id="308" id="homeherocarousel" className="relative w-full h-[100vh] min-h-[640px] overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0">
        {slides.map((slide, i) => <div key={i} data-index={i} className="absolute inset-0 transition-opacity duration-[2000ms] ease-in-out" style={{
        opacity: current === i ? 1 : 0
      }}>
            <img src={slide.src} data-wvc-srcset={slide.srcset} data-wvc-sizes={slide.sizes} alt={slide.alt} className="w-full h-full object-cover" loading={i === 0 ? "eager" : "lazy"} decoding="async" />
          </div>)}
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(to bottom, hsla(0, 0%, 0%, 0.2) 0%, hsla(0, 0%, 0%, 0.1) 35%, hsla(0, 0%, 0%, 0.4) 75%, hsla(0, 0%, 0%, 0.7) 100%)"
    }} />
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, transparent 50%, hsla(0, 0%, 0%, 0.4) 100%)"
    }} />

      {}
      <div className={`absolute top-6 left-6 md:top-10 md:left-10 z-10 transition-all duration-1000 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}>
        <p className="font-default text-[10px] md:text-[11px] tracking-[0.3em] uppercase text-white/85">
          <span className="text-primary">*</span>{" "}
          {currentSlide.location} — MMXXIV
        </p>
      </div>

      {}
      <div className="relative z-10 h-full flex flex-col justify-end items-center pb-24 md:pb-32 px-6">
        <div className={`max-w-6xl mx-auto text-center transition-all duration-1000 delay-200 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <p className="font-default text-[10px] md:text-[11px] tracking-[0.35em] uppercase mb-8 md:mb-10 text-white/90">
            Photography & Industrial Printing{" "}
            <span className="text-primary mx-2">
              *
            </span>{" "}
            Est. 2014
          </p>

          {}
          <h1 className="font-default font-light leading-[1.0] tracking-tight text-white" style={{
          fontSize: "clamp(3.5rem, 11vw, 9rem)"
        }}>
            <span className="block">Photo Glamour</span>
            <span className="block mt-2">
              Professional{" "}
              <span className="italic relative inline-block">
                Studio
                <span className={`absolute left-0 bottom-1 md:bottom-2 h-px transition-all duration-[1400ms] ease-out delay-700 ${loaded ? "w-full" : "w-0"}`} style={{
                backgroundColor: "var(--primary)"
              }} />
              </span>
            </span>
          </h1>

          {}
          <div className={`mt-10 md:mt-14 transition-all duration-1000 delay-[1100ms] ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <Button asChild variant="outline" size="lg" className="group bg-transparent border-2 h-12 px-8 font-default text-xs tracking-[0.25em] uppercase hover:bg-primary/20 border-white/60 text-white">
              <Link to="/StudioServicesPage">
                Explore Our Services
                <ArrowRight className="ml-1 size-4 transition-transform duration-500 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className={`absolute bottom-6 left-6 md:bottom-10 md:left-10 z-10 transition-all duration-1000 delay-[1300ms] ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
        <div className="flex items-end gap-4">
          <div className="font-default text-2xl md:text-3xl leading-none text-white">
            {slideNumber}
            <span className="text-white/50 mx-1">
              /
            </span>
            <span className="text-white/50">{totalSlides}</span>
          </div>
          <div className="hidden sm:block max-w-[220px] pb-1">
            <p key={current} className="font-default text-[10px] tracking-[0.25em] uppercase animate-[fadeIn_1s_ease-out] text-white/85">
              {currentSlide.caption}
            </p>
          </div>
        </div>
      </div>

      {}
      <div className={`absolute bottom-8 right-6 md:bottom-12 md:right-10 z-10 hidden sm:flex flex-col items-center gap-3 transition-all duration-1000 delay-[1400ms] ${loaded ? "opacity-100" : "opacity-0"}`}>
        <span className="font-default text-[10px] tracking-[0.35em] uppercase [writing-mode:vertical-rl] rotate-180 text-white/80">
          Scroll
        </span>
        <div className="relative w-px h-16 overflow-hidden bg-white/25">
          <div className="absolute top-0 left-0 w-full h-1/2 animate-[scrollLine_2s_ease-in-out_infinite] bg-white" />
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>;
}